import { unwrapResult } from '@reduxjs/toolkit';
import { useCallback, useState } from 'react';
import { slices, useAppDispatch, useAppSelector } from 'src/redux';
import { Supplier, SuppliersThunkRequest } from 'src/types/supplier';

const {
  actions: supplierActions,
  selectors: supplierSelectors
} = slices.supplier;

export const useSupplier = () => {
  const dispatch = useAppDispatch();
  const suppliers = useAppSelector(supplierSelectors.selectSupplierList);
  const [supplierOptions, setSupplierOptions] = useState<Supplier[]>();
  const [isSuppliersLoading, setIsSuppliersLoading] = useState<boolean>(false);

  const getSuppliers = useCallback(
    async (params: SuppliersThunkRequest) => {
      setIsSuppliersLoading(true);
      const response = unwrapResult(
        await dispatch(supplierActions.getSuppliersThunk(params))
      );
      if (response?.success) {
        setSupplierOptions(response?.originalData?.data);
      }
      setIsSuppliersLoading(false);
    },
    [dispatch]
  );

  return {
    suppliers,
    supplierOptions,
    isSuppliersLoading,
    setIsSuppliersLoading,
    getSuppliers
  };
};
